// extracted by mini-css-extract-plugin
export default {"container":"WishListPage_container__KMLqL","appear":"WishListPage_appear__auVAx","openTop":"WishListPage_openTop__EUmsC"};